import React from "react";

import "./bottomIconView.m.css";

const BottomIconView = () => {
  return (
    <div styleName="bottom-icon">
      <img src="/footerhaalfashion.svg" alt="হাল ফ্যাশন" />
    </div>
  );
};

export default BottomIconView;
